<template>
  <section id="SocialLogin">
    <transition name="fade">
      <div v-if="!showRegisterForm">
        <transition name="fade">
          <div
            class="d-flex justify-content-center align-items-center w-100 flex-xl-row flex-column-reverse bg-white"
            v-if="status === 'waiting'"
          >
            <div>
              <p class="big-title">
                {{ $t('Please wait')+"..." }}
              </p>
              <p class="title">
                {{ $t('Please wait, do not close this window.') }}
              </p>
            </div>
                        
            <img
              :src="imageWaiting"
              alt=""
            >
          </div>  
        </transition>
        <transition name="fade">
          <div
            class="d-flex justify-content-center align-items-center w-100 flex-xl-row flex-column-reverse bg-white"
            v-if="status === 'linkSuccess' || status === 'toLogin'"
          >
            <div>
              <p
                class="big-title"
                v-if="status === 'linkSuccess'"
              >
                {{ $t('Connection Success')+"..." }}
              </p>
              <p
                class="big-title"
                v-if="status === 'toLogin'"
              >
                {{ $t('Login Success')+"..." }}
              </p>
              <p class="title">
                {{ $t('Back to system')+" "+countDown+" "+$t('seconds.') }}
              </p>
            </div>
                        
            <img
              :src="imageSuccess"
              alt=""
            >
          </div>
        </transition>
        <transition name="fade">
          <div
            class="d-flex justify-content-center align-items-center w-100 flex-xl-row flex-column-reverse bg-white"
            v-if="status === 'alreadyAccount'"
          >
            <div>
              <p class="big-title">
                {{ $t('Connection Failed')+"..." }}
              </p>
              <p class="title">
                {{ $t('Account already in use. Please try another account.') }}
              </p>
              <router-link
                :to="{ name: 'account.profile'}"
                class="btn btn-primary mt-2"
              >
                <i class="fas fa-arrow-alt-circle-right mr-2" /> {{ $t('Go Back') }}
              </router-link>
            </div>
                    
            <img
              :src="imageFailed"
              alt=""
            >
          </div>
        </transition>
        <transition name="fade">
          <div
            class="d-flex justify-content-center align-items-center w-100 flex-xl-row flex-column-reverse bg-white"
            v-if="status === 'error'"
          >
            <div>
              <p class="big-title">
                {{ $t('Error')+"..." }}
              </p>
              <p class="title">
                {{ $t('Something went wrong. Please try again.') }}
              </p>
              <router-link
                :to="{ name: 'account.profile'}"
                class="btn btn-primary mt-2"
              >
                <i class="fas fa-arrow-alt-circle-right mr-2" /> {{ $t('Go Back') }}
              </router-link>
            </div>
                    
            <img
              :src="imageFailed"
              alt=""
            >
          </div>
        </transition>
      </div> 
    </transition>
    <transition name="fade">
      <div
        class="container"
        v-if="showRegisterForm"
      >
        <div class="d-flex justify-content-center h-100 p-4">
          <form
            class="login-form wmin-sm-400"
            action="index.html"
          >
            <div class="card mb-0">
              <div class="tab-content card-body">
                <div class="tab-pane fade show active">
                  <ConfirmInformation
                    register-type="socialRegister"
                    :social-user="userData"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </section>
</template>

<style scoped>
div.validation-invalid-label {
    display: none !important;
}

div.form-group-error>div.validation-invalid-label {
    display: block !important;
}
#SocialLogin .d-flex{
    height: 100vh;
}
#SocialLogin img{
    width: 917px;
}
#SocialLogin p.big-title{
    font-size: 50px;
    font-weight: bold;
}
#SocialLogin p.title{
    font-size: 16px;
}
@media only screen and (max-width: 1024px) {
    #SocialLogin img{
        width: 768px;
    }
    #SocialLogin p.big-title{
        padding-top: 2rem;
    }
}
@media only screen and (max-width: 767px) {
    #SocialLogin img{
        width: 400px;
    }
}
/* fade animate */
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to  {
    opacity: 0
}
/* fade animate */
</style>

<script>
import axios from 'axios';
import Cookies from 'js-cookie'
import CentralApi from '@/services/endpoint/central.service'
import ConfirmInformation from "@/components/central/authorization/ConfirmInformation"

export default {
    name: "SocialAccountCallback",
    components: {
        ConfirmInformation
    },
    data() {
        return {
            showRegisterForm:false,
            userData:{},
            imageWaiting:require("@/assets/images/connection_waiting.png"),
            imageFailed:require("@/assets/images/connection_failed.png"),
            imageSuccess:require("@/assets/images/connection_success.png"),
            countDown: 5,
            status:'waiting',
            redirect2Store:false
        };
    },
    methods: {
        async SocialiteLogin() {
            let loginUrl = process.env.API_BASE_URL;
            let token = Cookies.get('centralToken');
            
            const provider = this.$route.params.provider;

            if(token != null) {
                loginUrl = process.env.API_BASE_URI;
            }
           
            const queryString = new URLSearchParams(this.$route.query).toString();
            //make query to obj again and go to logic
            localStorage.setItem("SocialLoginStateWebsocket", this.$route.query.state) 
            if(provider == 'apple') {

                try {
                    const base64decode = window.atob(this.$route.query.code.toString())
                    const decryptedText = this.$CryptoJS.AES.decrypt(base64decode, process.env.NODE_ENV).toString(this.$CryptoJS.enc.Utf8)
                    const obj =  Object.fromEntries(new URLSearchParams(decryptedText)); 
                    
                    this.status = 'toRegister'

                    setTimeout(()=>{
                        this.userData = {
                            id:obj.id,
                            provider
                        }
                        this.showRegisterForm = true
                    }, 1000)
                    return
                } catch(err) {
                    this.status = 'error';
                    console.error({
                        err,
                        errMessage : err.message 
                    })
                }
                
            }
            
            let response;
            
            if(token != null){
                //connect to social auth
                response = async () => await CentralApi.Auth.socialCallback(provider,queryString)
            }else{
                //register or social
                response = async () => {
                    try {
                        return await axios.get(loginUrl + '/v1/auth/' + provider + '/callback?' + queryString);
                    } catch (error) {
                        return error.response;
                    }
                } 
            }
            
            const data = await response()
            
            const message = data.data.message
            this.status = message

            if(data.status != 200) {
                this.status = 'error';
                return
            }

            if(message === 'linkSuccess') {
                this.countDownTimer()
                return;
            }
            
            if(message === 'toLogin'){
                // return;
                const accessToken = data.data.user.access_token
                Cookies.set('centralToken', accessToken, { domain: '.' + process.env.CENTRAL_API_ROOT })
                this.redirect2Store = Cookies.get('loginBrowser') === 'gosaasApp' ? false : true;
                this.countDownTimer()
                return;
            }
            
            if(message === 'toRegister') {
              setTimeout(()=>{
                  this.userData = {
                    id: data.data.user.id,
                    email:data.data.user.email,
                    name: data.data.user.name,
                    provider
                  }
                  this.showRegisterForm = true
              }, 1000)
              return;
            }
           
            
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    if(this.countDown === 0) {
                        setTimeout(()=> {
                            if(this.redirect2Store){
                                window.location.href = process.env.CENTRAL_ACC_URL + '/store'
                                return
                            }
                            window.close()
                        } ,1000)
                    }
                    this.countDownTimer()
                }, 1000)
            }
        },
    },
    beforeCreate(){
        const error = this.$route.query.error
        if(error) window.close(); return;
    },
    mounted() {
      setTimeout(() => this.SocialiteLogin() , 1500);
    },
    watch: {
        showRegisterForm: function(value) {
            if(value) {
                document.body.classList.remove('central-public-layout')
                document.body.classList.add('central-authorization-layout')
            }else{
                document.body.classList.remove('central-authorization-layout')
                document.body.classList.add('central-public-layout')
            }
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/central/public/SocialAccountCallback.vue